<template>
  <div class="AtlasSummaryHeader">
    <template v-if="indicatorConfig">
      <atlas-summary-geo-picker
        class="AtlasSummaryHeader-picker"
        @pick="onPick"
        :default-geo-code="defaultGeoCode"
      />

      <atlas-summary-geo-banner
        class="AtlasSummaryHeader-banner"
        :geo-type-option="geoTypeOptions"
        :geo-option="geoOption"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import AtlasSummaryGeoBanner from './summary-geo-banner.vue';
import AtlasSummaryGeoPicker from './summary-geo-picker.vue';

/**
 * @deprecated in favor of <indicator-summary>
 *
 * Geo controls live outside of <indicator-summary>
 * using indicator store for data exchange.
 */
export default {
  name: 'atlas-summary-header',

  emits: ['pick'],

  components: {
    AtlasSummaryGeoBanner,
    AtlasSummaryGeoPicker,
  },

  props: {
    indicatorId: {
      type: Number,
      required: true,
    },

    defaultGeoCode: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    geoTypeOptions: null,
    geoOption: null,
  }),

  computed: {
    ...mapGetters('indicator', ['indicatorConfig']),
  },

  watch: {
    indicatorId: {
      immediate: true,
      handler(id) {
        this.fetchIndicator({ id });
      },
    },
  },

  methods: {
    ...mapActions('indicator', ['fetchIndicator']),

    onPick({ geoType, geo }) {
      this.geoTypeOptions = geoType;
      this.geoOption = geo;
      this.$emit('pick', { geoType, geo });
    },
  },
};
</script>

<style lang="scss">
.AtlasSummaryHeader {
  &-picker {
    margin-bottom: 60px;
  }
}
</style>
